export const initialConfig = {
  sidePadding: '104px',
  columnGap: '32px',
  totalColumns: 12,
};
